import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const NotificationContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const NotificationProvider = ({ children }) => {
  const { getAuthHeader, admin } = useAuth();
  const [newConsultationsCount, setNewConsultationsCount] = useState(0);

  useEffect(() => {
    if (admin) {
      fetchNewConsultationsCount();
      // Poll every 30 seconds for new consultations
      const interval = setInterval(fetchNewConsultationsCount, 30000);
      return () => clearInterval(interval);
    }
  }, [admin]);

  const fetchNewConsultationsCount = async () => {
    try {
      const response = await axios.get(
        `${API}/admin/consultations/stats/summary`,
        { headers: getAuthHeader() }
      );
      setNewConsultationsCount(response.data.new);
    } catch (error) {
      console.error('Failed to fetch consultation stats:', error);
    }
  };

  const refreshNotifications = () => {
    fetchNewConsultationsCount();
  };

  return (
    <NotificationContext.Provider value={{ 
      newConsultationsCount, 
      refreshNotifications 
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within NotificationProvider');
  }
  return context;
};
